import React, { Component } from 'react';
import moment from 'moment';

const FORMAT_DATE = "YYYY年MM月DD日（ddd）";
const FORMAT_TIME = "HH:mm:ss";

if (Number.parseInt === undefined) {
    Number.parseInt = window.parseInt;
}

// 内側のcircleの状態
const INNER_CIRCLE = {
    NORMAL   : 0,   // 通常時
    COMPLETE : 1,   // NORMALからFILLEDに移る直前
    FILLED   : 2,   // 一周描画された状態
    DRAWING  : 3,   // 未描画状態からFILLEDまで一気に描画する場合
};

// IE対策用
const ua = window.navigator.userAgent.toLowerCase();
const isMS = (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1 || ua.indexOf('edge') !== -1);
const draw4MS = () => {
    let sel = window.getSelection();
    const circleBox = document.querySelector(".time-circle-box");
    sel.removeAllRanges();
    circleBox.focus();
    sel.selectAllChildren(circleBox);
    circleBox.blur();
    sel.removeAllRanges();
    circleBox.click();
}
let count = 1;

export default class TimeProgressView extends Component {
    intervalID = null
    drawHandle = null

    constructor(props) {
        super(props)

        // console.log('TimeProgressView props', this.props);

        // const now = moment();
        this.state = {
            currentDate: '----年--月--日（-）',
            currentTime: '--:--:--',
            // currentDate: now.format(FORMAT_DATE),
            // currentTime: now.format(FORMAT_TIME),
            startDate: '勤務日 ----年--月--日',
            startTime: '勤務開始時刻 --:--',
            durationTime: '',
            // durationTime: '--:--',
            progressLabel: '',
            process: 0,
        };
    }

    componentDidMount() {
        this.intervalID = setInterval(this.updateDateTime, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    drawingCircle = (start, end) => {
        window.cancelAnimationFrame(this.drawHandle);
        let circle = null;
        if (this.refs.timeCircle) {
            circle = this.refs.timeCircle;
            if (this.isInnerCircleFilled === INNER_CIRCLE.FILLED) {
                if (circle.classList && circle.classList.contains('overwork')) {
                    circle = this.refs.timeCircleOverwork;
                } else { // for IE
                    const circleClasses = circle.getAttribute('class');
                    if (circleClasses && circleClasses.indexOf('overwork') !== -1) {
                        circle = this.refs.timeCircleOverwork;
                    }
                }
            }
        } else { // for IE
            circle = document.getElementById('time-circle');
            const circleClasses = circle.getAttribute('class');
            if (circleClasses && circleClasses.indexOf('overwork') !== -1) {
                circle = document.getElementById('time-circle-overwork');
            }
        }

        const duration = 500;
        const totalLength = circle.getTotalLength();

        circle.style.strokeDasharray = totalLength;

        let current = Math.floor(duration * start);

        // console.log('start', start, 'end', end, 'current', current);

        // アニメーション
        let draw = () => {
            let progress = current / duration;

            if (progress > end) {
                window.cancelAnimationFrame(this.drawHandle);
                if (this.isInnerCircleFilled === INNER_CIRCLE.DRAWING || this.isInnerCircleFilled === INNER_CIRCLE.COMPLETE)
                    this.isInnerCircleFilled = INNER_CIRCLE.FILLED;
                if (isMS && count > 0) {
                    draw4MS();
                    count--;
                }
                return;
            }

            current++;
            circle.style.strokeDashoffset = Math.floor(totalLength * (1.0 - progress));
            this.drawHandle = window.requestAnimationFrame(draw);
        }

        draw();
    }

    updateDateTime = () => {
        let newState = {
            currentDate: '----年--月--日（-）',
            currentTime: '--:--:--',
            startDate: '勤務日 ----年--月--日',
            startTime: '勤務開始時刻 --:--',
            durationTime: '',
            progressLabel: '',
        };

        const record = this.props.record;
        if (!record || !record.currentTime) {
            this.setState(newState);
            return;
        }

        const now = moment(moment() + record.diff);
        newState.currentDate = now.format(FORMAT_DATE);
        newState.currentTime = now.format(FORMAT_TIME);

        if (isMS && /.*1$/.test(newState.currentTime)) {
            // Microsoft系のブラウザで描画が正常に行われない場合があるのでその対策
            draw4MS();
        }

        if (!record.startWork) {
            this.setState(newState);
            return;
        }
        // const now = moment();
        //
        // let newState = {
        //     currentDate: now.format(FORMAT_DATE),
        //     currentTime: now.format(FORMAT_TIME),
        //     startDate: '勤務日 ----年--月--日',
        //     startTime: '勤務開始時刻 --:--',
        //     durationTime: '',
        //     // durationTime: '--:--',
        //     progressLabel: '',
        // };
        //
        // if (isMS && /.*1$/.test(newState.currentTime)) {
        //     // Microsoft系のブラウザで描画が正常に行われない場合があるのでその対策
        //     draw4MS();
        // }
        //
        // const record = this.props.record;
        // if (!record || !record.startWork) {
        //     this.setState(newState);
        //     return;
        // }

        newState.startDate = '勤務日 ' + moment(record.recordDate).format(FORMAT_DATE);

        let prevProgress = this.state.progress || 0;
        let progress = 0;

        let startDateTime, endDateTime;

        if (!record.startWork) {
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.remove('breaktime');
            } else { // for IE
                document.getElementById('time-circle').setAttribute('class', '');
            }

            newState.startTime = '勤務開始時刻 --:--';
            newState.durationTime = '';
            // newState.durationTime = '--:--';
        } else if (record.endWork) { // if endWork exists, it's fixed progress
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.remove('breaktime');
            } else { // for IE
                document.getElementById('time-circle').setAttribute('class', '');
            }

            if (!record.startWork.time || !record.endWork.time) {
                progress = 0.0;
            } else {
                startDateTime = moment(`${record.recordDate} ${record.startWork.time}`, 'YYYY-MM-DD HH:mm');

                // After press "fprgetPut", record.endWork.time can be "null".
                const addHours = Number.parseInt(record.endWork.time.slice(0, 2), 10);
                const addMinutes = Number.parseInt(record.endWork.time.slice(-2), 10);

                endDateTime = moment(record.recordDate).add(addHours, 'hours').add(addMinutes, 'minutes');

                // 100% is 12 hours
                progress = (endDateTime.diff(startDateTime, 'minutes') / 60.0) / 12.0;
            }

            // duration time is until end work time
            newState.startTime = `勤務開始時刻 ${(record.startWork.time === null ? '--:--' : record.startWork.time)}`;
            newState.progressLabel = `勤務終了時刻 ${(record.endWork.time === null ? '--:--' : record.endWork.time)}`;

            newState.durationTime = '';
            // newState.durationTime = endDateTime
            //     .add(-(startDateTime.hour()), 'h')
            //     .add(-(startDateTime.minute()), 'm')
            //     .format('HH:mm:ss');
        } else if (record.numberOfBreak > 0 && record.breakTimeItems
            && record.breakTimeItems[record.numberOfBreak - 1].start
            && !record.breakTimeItems[record.numberOfBreak - 1].end) {
            // It's still having break time.
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.add('breaktime');
            } else { // for IE
                document.getElementById('time-circle').setAttribute('class', 'breaktime');
            }

            const recordStartBreakTime = record.breakTimeItems[record.numberOfBreak - 1].start.time;
            if (window.pressStartBreakTime !== undefined) {
                startDateTime = window.pressStartBreakTime.clone();
            } else {
                let addHours = Number.parseInt(recordStartBreakTime.slice(0, 2), 10);
                let addMinutes = Number.parseInt(recordStartBreakTime.slice(-2), 10);
                startDateTime = moment(record.recordDate).add(addHours, 'hours').add(addMinutes, 'minutes');
            }

            endDateTime = now.clone();

            // 100% is an hour
            progress = now.diff(startDateTime, 'minutes') / 60.0;

            // start time is start break time
            // duration time is until current time
            newState.startTime = `休憩開始時刻 ${recordStartBreakTime}`;
            newState.progressLabel = '経過';

            // newState.durationTime = endDateTime
            //     .add(-(startDateTime.hour()), 'h')
            //     .add(-(startDateTime.minute()), 'm')
            //     .add(-(startDateTime.second()), 's')
            //     .format('HH:mm:ss');
            // 上記では日付をまたいだ場合の表示が狂うので修正
            // 及び、100時間を超えた場合99:59:59で固定
            if (progress < 100) {
                const diff = {
                    h: endDateTime.diff(startDateTime, 'hours'),
                    m: endDateTime.diff(startDateTime, 'minutes'),
                    s: endDateTime.diff(startDateTime, 'seconds'),
                }
                newState.durationTime = `${`0${diff.h}`.substr(-2)}:${`0${diff.m - diff.h * 60}`.substr(-2)}:${`0${Math.max(diff.s - diff.m * 60, 0)}`.substr(-2)}`
            } else {
                newState.durationTime = '99:59:59'
            }
        } else {
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.remove('breaktime');
            } else { // for IE
                document.getElementById('time-circle').setAttribute('class', '');
            }

            if (!record.startWork.time) {
                progress = 0.0;
            } else {
                // After press "fprgetPut", record.startWork.time can be "null".
                const addHours = Number.parseInt(record.startWork.time.slice(0, 2), 10);
                const addMinutes = Number.parseInt(record.startWork.time.slice(-2), 10);

                startDateTime = moment(record.recordDate).add(addHours, 'hours').add(addMinutes, 'minutes');

                endDateTime = now.clone();

                // 100% is 12 hours
                progress = (now.diff(startDateTime, 'minutes') / 60.0) / 12.0;
            }

            // duration time is until current time
            newState.startTime = `勤務開始時刻 ${(record.startWork.time === null ? '--:--' : record.startWork.time)}`;
            newState.progressLabel = '';
            // newState.progressLabel = '経過';

            newState.durationTime = '';
            // newState.durationTime = endDateTime
            //     .add(-(startDateTime.hour()), 'h')
            //     .add(-(startDateTime.minute()), 'm')
            //     .format('HH:mm:ss');
        }

        let overflow = progress;
        let onlySetState = false;
        if (progress > 1.0) {
            switch (this.isInnerCircleFilled) {
                case INNER_CIRCLE.DRAWING:
                case INNER_CIRCLE.COMPLETE:
                    onlySetState = true;
                    break;
                case INNER_CIRCLE.FILLED:
                    overflow = progress - 1.0;
                    break;
                case undefined:
                    overflow = 1.0;
                    this.isInnerCircleFilled = INNER_CIRCLE.DRAWING;
                    break;
                default:
                    overflow = 1.0;
                    this.isInnerCircleFilled = INNER_CIRCLE.COMPLETE;
                    break;
            }
        } else {
            this.isInnerCircleFilled = INNER_CIRCLE.NORMAL;
        }

        if (this.isInnerCircleFilled === INNER_CIRCLE.DRAWING || this.isInnerCircleFilled === INNER_CIRCLE.COMPLETE) {
            newState.progress = 0;
        } else {
            newState.progress = overflow;
        }
        this.setState(newState);

        if (onlySetState) {
            return;
        }

        if (overflow > 1.0) {
            overflow = 1.0;
        }

        if (prevProgress > overflow) {
            prevProgress = overflow;
        }

        if (progress < 1.0) {
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.remove('overwork');
                this.refs.timeCircleOverwork.style.strokeDashoffset = this.refs.timeCircleOverwork.getTotalLength();
            } else { // for IE
                const outerCircle = document.getElementById('time-circle-overwork');
                outerCircle.style.strokeDashoffset = outerCircle.getTotalLength();
                let prevClasses = document.getElementById('time-circle').getAttribute('class');
                if (prevClasses && prevClasses.indexOf('breaktime') !== -1) {
                    document.getElementById('time-circle').setAttribute('class', 'breaktime');
                } else {
                    document.getElementById('time-circle').setAttribute('class', '');
                }
            }
        } else if (this.isInnerCircleFilled === INNER_CIRCLE.FILLED) {
            if (this.refs.timeCircle.classList) {
                this.refs.timeCircle.classList.add('overwork');
                if (this.refs.timeCircle.classList.contains('breaktime'))
                    this.refs.timeCircleOverwork.classList.add('breaktime');
                else
                    this.refs.timeCircleOverwork.classList.remove('breaktime');
            } else { // for IE
                const innerCircle = document.getElementById('time-circle');
                let prevClasses = innerCircle.getAttribute('class');
                if (prevClasses && prevClasses.indexOf('breaktime') !== -1) {
                    document.getElementById('time-circle').setAttribute('class', 'breaktime overwork');
                    document.getElementById('time-circle-overwork').setAttribute('class', 'breaktime');
                } else {
                    document.getElementById('time-circle').setAttribute('class', 'overwork');
                    document.getElementById('time-circle-overwork').setAttribute('class', '');
                }
            }
        }

        if (this.isInnerCircleFilled === INNER_CIRCLE.DRAWING) {
            this.drawingCircle(0, 1);
        } else {
            this.drawingCircle(prevProgress, overflow);
        }
    }

    render() {
        return (
            <div className="p-4">
                <div>
                    <div className="current-date">{this.state.currentDate}</div>
                    <div className="current-time">{this.state.currentTime}</div>
                </div>
                <div
                    className="time-circle-box">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="540" height="540">
                        <path className="time-bg-circle"
                            d="M270,270 m0 -225 a 225 225 0 0 1 0 450 a 225 225 0 0 1 0 -450" />
                        <path id="time-circle"
                            ref="timeCircle"
                            strokeDasharray="1413.7167"
                            strokeDashoffset="1413.7167"
                            d="M270,270 m0 -225 a 225 225 0 0 1 0 450 a 225 225 0 0 1 0 -450" />
                        <path id="time-circle-overwork"
                            ref="timeCircleOverwork"
                            strokeDasharray="1489.115"
                            strokeDashoffset="1489.115"
                            d="M270,270 m0 -237 a 237 237 0 0 1 0 474 a 237 237 0 0 1 0 -474" />
                    </svg>
                    <div className="duration-time-box">
                        <div className="start-work-date">{this.state.startDate}</div>
                        <div className="start-work-time">{this.state.startTime}</div>
                        <div className="duration-time">{this.state.durationTime}</div>
                        <div className="progress-work-time">{this.state.progressLabel}</div>
                    </div>
                </div>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/record/TimeProgressView.js